import React from "react"
import { Box, Skeleton } from "@mui/material"
import PropTypes from "prop-types"

const LINE_PATHS = [
    [66, 48, 58, 32, 42, 22],
    [78, 68, 72, 54, 62, 46],
    [88, 82, 76, 80, 66, 70],
]

const SkeletonChart = ({ height = 400 }) => (
    <Box
        aria-label="Carregando gráfico"
        aria-busy="true"
        sx={{
            width: "100%",
            height,
            minHeight: 280,
            p: {xxxs: 2, sm: 3},
            boxSizing: "border-box",
        }}
    >
        <Box sx={{display: "flex", gap: 1.5, mb: 3}}>
            {[72, 96, 84].map((width) => (
                <Skeleton
                    key={width}
                    variant="rounded"
                    width={width}
                    height={22}
                    animation="wave"
                    sx={{bgcolor: "rgba(255, 255, 255, 0.12)"}}
                />
            ))}
        </Box>

        <Box sx={{display: "flex", height: "calc(100% - 52px)"}}>
            <Box sx={{width: 34, display: "flex", flexDirection: "column", justifyContent: "space-between", pb: 2}}>
                {[1, 2, 3, 4, 5].map((item) => (
                    <Skeleton key={item} width={22} height={12} sx={{bgcolor: "rgba(255, 255, 255, 0.1)"}} />
                ))}
            </Box>

            <Box
                sx={{
                    position: "relative",
                    flex: 1,
                    borderLeft: "1px solid rgba(255, 255, 255, 0.25)",
                    borderBottom: "1px solid rgba(255, 255, 255, 0.25)",
                    backgroundImage: "linear-gradient(rgba(255,255,255,.07) 1px, transparent 1px)",
                    backgroundSize: "100% 25%",
                    overflow: "hidden",
                }}
            >
                {LINE_PATHS.map((points, lineIndex) => (
                    <Box
                        key={lineIndex}
                        sx={{position: "absolute", inset: 0, display: "flex", alignItems: "flex-end"}}
                    >
                        {points.map((bottom, pointIndex) => (
                            <Skeleton
                                key={pointIndex}
                                variant="circular"
                                width={10}
                                height={10}
                                animation="wave"
                                sx={{
                                    position: "absolute",
                                    left: `${8 + pointIndex * 17}%`,
                                    bottom: `${bottom}%`,
                                    bgcolor: lineIndex === 0 ? "primary.main2" : "rgba(255, 255, 255, 0.2)",
                                }}
                            />
                        ))}
                    </Box>
                ))}
            </Box>
        </Box>
    </Box>
)

SkeletonChart.propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default SkeletonChart
